export class CustomAdjustmentTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomAdjustmentType(params) {
    return this.#http.get('/api/custom-adjustment-types', { params });
  }

  async editCustomAdjustmentType({ customAdjustmentTypeId, ...body }) {
    return this.#http.put(`/api/custom-adjustment-types/${customAdjustmentTypeId}`, body);
  }

  async activateCustomAdjustmentType({ customAdjustmentTypeId }) {
    return this.#http.put(`/api/custom-adjustment-types/${customAdjustmentTypeId}/activate`);
  }

  async createCustomAdjustmentType(body) {
    return this.#http.post('/api/custom-adjustment-types', body);
  }

  async deleteCustomAdjustmentType({ customAdjustmentTypeId }) {
    return this.#http.delete(`/api/custom-adjustment-types/${customAdjustmentTypeId}`);
  }
}
